// Utility function to decode JWT token and extract user information
export interface DecodedJWT {
  sub: string; // organization_id or user_id
  email: string;
  organization?: string; // Only for regular organization users
  is_super_user: boolean;
  user_type?: number; // 0 = Regular user, 1 = SuperUser, 2 = ProtocolManager
  assigned_organizations?: string[]; // For ProtocolManagers
  iat: number; // issued at
  exp: number; // expiration
}

export const decodeJWT = (token: string): DecodedJWT | null => {
  try {
    // JWT tokens have 3 parts separated by dots
    const parts = token.split('.');
    if (parts.length !== 3) {
      console.error('Invalid JWT token format');
      return null;
    }

    // Decode the payload (second part)
    const payload = parts[1];
    const decodedPayload = atob(payload);
    
    return JSON.parse(decodedPayload);
  } catch (error) {
    console.error('Error decoding JWT token:', error);
    return null;
  }
};

export const isSuperUser = (token: string): boolean => {
  const decoded = decodeJWT(token);
  return decoded?.is_super_user === true || decoded?.user_type === 1;
};

export const isProtocolManager = (token: string): boolean => {
  const decoded = decodeJWT(token);
  return decoded?.user_type === 2;
};

export const getUserType = (token: string): number => {
  const decoded = decodeJWT(token);
  return decoded?.user_type || 0;
};

export const getAssignedOrganizations = (token: string): string[] => {
  const decoded = decodeJWT(token);
  return decoded?.assigned_organizations || [];
};

export const getOrganizationId = (token: string): string | null => {
  const decoded = decodeJWT(token);
  return decoded?.sub || null;
};

export const getOrganizationName = (token: string): string | null => {
  const decoded = decodeJWT(token);
  return decoded?.organization || null;
};
